<template>
  <section id="recentNews">
    <div class="container">
      <div class="columns has-text-left">
        <div v-for="(post, key) in topPosts" :key="key" class="column is-one-third-desktop">
          <nuxt-link :to="'/posts/'+post.title_slug">
            <img v-if="post.image.path" :src="'https://pitadmin.beneship.com/api/cockpit/image?token=68ba1b5eef8183911adad1903c81b9&src=https://pitadmin.beneship.com/storage/uploads' + post.image.path +'&w=456&h=200&o=1'" :alt="post.image.title">
            <div v-if="!post.image.path" class="imagePlaceholder"><div /></div>
            <div style="padding: 2em;">
              <h3>{{ post.title }}</h3>
              <span class="posted">POSTED {{ post.datePublished | toDate }}</span>
              <div class="postContent" v-html="post.excerpt" />
            </div>
            <div class="readMore" style="background: #ddd; text-align: center; padding: 0.7em 0em; color: #888;">
              Read More
            </div>
          </nuxt-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    posts: {
      type: Array,
      default: Array.new
    }
  },
  computed: {
    topPosts () {
      return this.posts.filter((p, i) => i < 3)
    }
  }
}
</script>

<style scoped>
  h3{
    line-height: 1.2em;
    margin-bottom: 0.3em;
  }
</style>
